export const modelConstants = {
    vinLength: 17
};

export function isValidVin(value: string) {

    return value.length === modelConstants.vinLength;
}
